import { render, staticRenderFns } from "./CompanyJoinRequest.vue?vue&type=template&id=1599927a"
import script from "./CompanyJoinRequest.vue?vue&type=script&lang=js"
export * from "./CompanyJoinRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports